import React from "react";
import {WidgetsSkeleton} from "../app/hungryscan/dashboard/stats/WidgetsSkeleton";
import {useWindowWidth} from "../hooks/useWindowWidth";
import {SkeletonWrapper} from "../app/hungryscan/dashboard/stats/SkeletonWrapper";
import {NavPanelSkeleton} from "../app/hungryscan/navigation/NavPanelSkeleton";

export const AppSkeleton = () => {
    const windowWidth = useWindowWidth();
    const isTablet = windowWidth < 1000;

    return (
        <SkeletonWrapper>
            <div className={'app-flex'}>
                {!isTablet && <NavPanelSkeleton/>}
                <div className={'cms-main'}>
                    <div className={'statistics-content'}>
                        <WidgetsSkeleton/>
                    </div>
                </div>
            </div>
        </SkeletonWrapper>
    );
};